import React, { useState, useMemo, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import { orderBy } from "lodash";

import ReportFilters from "../../../ReportFiltersComponent";

import DropdownSearch from "../../../../common/DropdownSearch";

import * as departmentActions from "../../../../../actions/departmentActions";
import * as reportActions from "../../../../../actions/reportActions";

const DailyCallCompletionFilters = ({
  departments,
  codes,
  actions,
  loading,
  onExportClick,
  exporting
}) => {
  const [filters, setFilters] = useState({
    department: null,
    request_status: null
  });

  useEffect(() => {
    if (codes.length) {
      const IPStatus = codes.find(
        (code) =>
          code.entity === "Support Ticket" &&
          code.field === "status" &&
          code.label === "In Process"
      );
      setFilters((prev) => ({ ...prev, request_status: IPStatus._id }));
    }
  }, [codes]);

  useEffect(() => {
    actions.loadDepartments();
  }, [actions]);

  const handleChange = (name, data) => {
    setFilters((prev) => ({ ...prev, [name]: data.value }));
  };

  const handleResetFilters = () => {
    const IPStatus = codes.find(
      (code) =>
        code.entity === "Support Ticket" &&
        code.field === "status" &&
        code.label === "In Process"
    );
    setFilters({ department: null, request_status: IPStatus._id });
    actions.clearReport();
  };

  const fetchData = () => {
    if (filters.request_status) {
      actions.getOpenSupportTicketsReport(filters);
    }
  };

  const departmentOptions = useMemo(() => {
    const options = departments.map((dep) => ({
      value: dep._id,
      label: dep.description
    }));
    return orderBy(options, [(option) => option.label.toLowerCase()]);
  }, [departments]);

  const statusOptions = useMemo(() => {
    const options = codes
      .filter(
        (code) => code.entity === "Support Ticket" && code.field === "status"
      )
      .map((code) => ({
        value: code._id,
        label: code.label
      }));
    return orderBy(options, [(option) => option.label.toLowerCase()]);
  }, [codes]);

  return (
    <ReportFilters
      onFetchClick={fetchData}
      onResetClick={handleResetFilters}
      title="Open Support Tickets Report"
      loading={loading}
      csvExportAvailable
      onCSVExport={onExportClick}
      exportDisabled={loading || exporting}
    >
      <Row>
        <Col md={3}>
          <DropdownSearch
            label="Department"
            placeholder="Select"
            name="department"
            onChange={handleChange}
            value={filters.department}
            data={departmentOptions}
          />
        </Col>
        <Col md={3}>
          <DropdownSearch
            label="Status *"
            placeholder="Select"
            name="request_status"
            onChange={handleChange}
            value={filters.request_status}
            data={statusOptions}
          />
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <label
            className="control-label"
            style={{ textTransform: "uppercase" }}
          >
            * Required Fields
          </label>
        </Col>
      </Row>
    </ReportFilters>
  );
};

DailyCallCompletionFilters.propTypes = {
  departments: PropTypes.array,
  codes: PropTypes.array,
  actions: PropTypes.object,
  loading: PropTypes.bool,
  onExportClick: PropTypes.func,
  exporting: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    auth: state.reducers.auth,
    departments: state.reducers.departments,
    codes: state.reducers.codes,
    loading: state.reducers.loading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...departmentActions,
        ...reportActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(DailyCallCompletionFilters);
